<div class="dialog">
    <mat-dialog-content class="dialog-content">
        <p class="mb-4">Please select elements to include in download.</p>

        <ng-table #csvElementsToIncludeTable [rows]="csvElementsToIncludeRows" [columns]="csvElementsToIncludeColumns"
            [maxHeight]="50" [showCheckbox]="true" (checkedItemEvent)="selectItem()">
        </ng-table>
        <div class="error-message mt-3" *ngIf="invalidSelected">
            Please select at least one elements to include in download
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center mt-3">
        <button class="btn btn-greengo" mat-button (click)="download()" [disabled]="invalidSelected">
            OK
        </button>
        <button class="btn btn-lead-50" mat-button mat-dialog-close [mat-dialog-close]="false">Cancel</button>
    </mat-dialog-actions>
</div>